import { useCallback } from 'react'
import { useStore } from '@/models'
import { playSound, SoundType } from '../utils/audioService'

type UseSoundEffectOptions = {
  volume?: number
}
export const useSoundEffect = (sound: SoundType, options?: UseSoundEffectOptions) => {
  // TODO: remove dependency for MST store, create dedicated store for game config
  const {
    permissions: { isSoundEnabled }
  } = useStore()

  const play = useCallback(() => {
    if (sound && isSoundEnabled) {
      playSound(sound)
    }
  }, [sound, isSoundEnabled])

  return {
    playSound: play
  }
}
